module.exports = __webpack_public_path__ + "img/banner4.7e79c646.png";